const ShimmerLoader = () => {
    return (
        <li className="list-group-item bg-transparent border-0 px-1">
            <div className="row align-items-center py-2">
                <div className="col-3 px-0 d-flex justify-content-end">
                    <div className="shimmer-wrapper" style={{ width: '70%', height: '24px' }}></div>
                </div>
                <div className="col-8">
                    <div className="row align-items-center">
                        <div className="col-8">
                            <div className="shimmer-wrapper" style={{ width: '90%', height: '20px' }}></div>
                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <div className="shimmer-wrapper" style={{ width: '60%', height: '14px' }}></div>
                        </div>
                    </div>
                </div>
                <div className="col-1 d-flex justify-content-end pe-0">
                    <div className="shimmer-wrapper" style={{ width: '4px', height: '18px', borderRadius: '2px' }}></div>
                </div>
            </div>
        </li>
    )
}

export default ShimmerLoader;